module.exports = __webpack_public_path__ + "img/sub_training_icon2.0acc6757.png";